<button type="button" mat-icon-button (click)="onResolveClick()">
  <fa-icon [icon]="['fal', 'check-circle']" [matTooltip]="tooltip"></fa-icon>
</button>
